export const parseAgeRange = (min: number | null, max: number | null): string => {
  if (min !== null && max !== null) {
    return `${min}-${max}`;
  } else if (min === null) {
    return `${max}-`;
  } else {
    return `${min}+`;
  }
};
